import { Category } from "fe-common/graphql";
import { DataInputPanel } from "../../dataInputTypes";
import { panelGroupToCaseGrouping } from "../usePatientCase";
import { PatientCaseGrouping } from "../../../context/diagnosticAgent";
import { useMemo } from "react";

function topLevelPanels(
  panels: Map<Category, DataInputPanel[]>,
): Array<TopLevelPanelItem> {
  return [...(panels || [])]
    .flatMap(([cat, list]) => {
      if (cat === TOPLEVEL_PANEL_GROUP || list?.length < 2) {
        // these are top level panels, each gets its own entry
        return list?.map(
          (p) =>
            [
              {
                id: p.panelSubgroup?.id || p.id,
                name: p.name,
                shortname: p.shortname,
              },
              [p],
            ] as TopLevelPanelItem,
        );
      } else {
        // these are sub groups
        return [[cat, list]] as TopLevelPanelItem[];
      }
    })
    .sort(([c1], [c2]) => compareByShortName(c1, c2));
}

function organizePanels(
  panels: DataInputPanel[],
): Map<Category, DataInputPanel[]> {
  // map by sub group
  return (
    panels
      //.filter((p) => p.findings?.length > 0)
      .reduce((map, p) => {
        let subgroup = p.panelSubgroup || TOPLEVEL_PANEL_GROUP;
        const key = Array.from(map.keys()).find(
          (key) => key.id === subgroup.id,
        );
        let curval = map.get(key);
        return map.set(key ? key : subgroup, curval ? [...curval, p] : [p]);
      }, new Map<Category, DataInputPanel[]>())
  );
}

export function panelSectionOfList(list: DataInputPanel[]) {
  return panelGroupToCaseGrouping(list[0]?.panelGroup?.id);
}

export const useOrganizedPanels = (
  panels: DataInputPanel[],
  categoryid: string, // routers -> /:panelId
  section: PatientCaseGrouping,
) =>
  useMemo(() => {
    const organizedPanels = panels && organizePanels([...panels]);
    const panelsBySubGroup = topLevelPanels(organizedPanels);
    // if no inital selected subgroup - set an initial selection
    let initialSubgroup = categoryid
      ? panelsBySubGroup.find(([cat]) => cat.id === categoryid)?.[0]
      : section
      ? panelsBySubGroup.find(
          ([cat, list]) => panelSectionOfList(list) === section,
        )?.[0]
      : panelsBySubGroup[0]?.[0];

    return { panelsBySubGroup, initialSubgroup };
  }, [panels, categoryid, section]);

const TOPLEVEL_PANEL_GROUP: Category = {
  name: "All",
  id: "All",
  shortname: "All",
};
export type TopLevelPanelItem = [Category, DataInputPanel[]];

export function compareByShortName(
  a: { shortname?: string },
  b: { shortname?: string },
) {
  return (a?.shortname || "").localeCompare(b?.shortname || "");
}

//region  DataInput Response

//endregion  DataInput Response
